import { Box, Divider, Grid, Stack, Typography } from '@mui/material'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import React from 'react'
import { ContainerCustomV2 } from '@/components/common/container-custom-v2'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined'
import HTMLReactParser from 'html-react-parser/lib/index'
import { URL_ICON, URL_IMG } from '@/constants/ui'
import { Image } from '@/components'

const listQuality = [
  {
    icon: 'ic-shipping.svg',
    title: 'Giao hàng miễn phí, cho đơn từ 400k',
  },
  {
    icon: 'ic-sync.svg',
    title: 'Đổi trả trong 15 ngày, không cần lí do',
  },
  {
    icon: 'ic-inventory.svg',
    title: 'Gói hộp miễn phí, khi mua combo từ 3 sản phẩm trở lên',
  },
  {
    icon: 'ic-volunteer.svg',
    title: 'Đảm bảo nhận hàng nguyên vẹn',
  },
]

export default function PanelQuality() {
  return (
    <>
      <Box
        position={'relative'}
        overflow="hidden"
        sx={{
          pt: {
            xs: 2,
            md: 0,
          },
          borderTop: {
            xs: '1px solid #eee',
            md: 'unset',
          },
        }}
      >
        <Grid container spacing={2} position="relative" zIndex={1}>
          {listQuality.map((item, index) => (
            <Grid key={index} size={12} position="relative" borderRadius={'0.4rem'} overflow="hidden">
              <Stack direction="row" spacing={1}>
                <Image
                  src={URL_ICON + item.icon}
                  alt={item.title}
                  style={{ width: '20px', height: '20px' }}
                />
                <Typography
                  variant="h6"
                  fontWeight="semiBold"
                  color={index == 0 ? 'five.main' : 'primary.main'}
                  fontSize={{
                    xs: '12px',
                    lg: '14px',
                  }}
                >
                  {HTMLReactParser(item.title)}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}
